import { Link, useLocation } from 'react-router';
import { HouseIcon, SparkleIcon, UserCircleIcon } from '@phosphor-icons/react';
import { AppBar, IconButton } from '@/components/kit';
import { useAssistantNav } from '@/features/assistant/useAssistantNav';
import { useStudio } from './studio-data';

/**
 * Minimal top bar of the client screens: studio mark on the left; the assistant and
 * «Моя запись» (or «На главную» on that page) on the right. On the home page it sits
 * on the hero photo (`overlay`).
 */
export function ClientHeader({ overlay = false }: { overlay?: boolean }) {
  const studio = useStudio();
  const assistant = useAssistantNav();
  const { pathname } = useLocation();
  const base = `/s/${studio.slug}`;
  const onMy = pathname.startsWith(`${base}/my`);
  const onHome = pathname === `${base}/` || pathname === base;

  return (
    <AppBar
      logoPath={studio.logoPath}
      name={studio.shortName}
      homeTo={onHome ? undefined : `${base}/`}
      className={overlay ? 'ui-appbar--overlay' : undefined}
      end={
        <span className="ui-row" style={{ ['--ui-gap' as string]: '2px' }}>
          {studio.aiEnabled ? <IconButton icon={SparkleIcon} label="Помощник студии" onClick={() => assistant.open()} /> : null}
          {onMy ? (
            <Link to={`${base}/`} className="ui-icon-btn" aria-label="На главную" title="На главную">
              <HouseIcon size={20} aria-hidden />
            </Link>
          ) : (
            <Link to={`${base}/my`} className="ui-icon-btn" aria-label="Моя запись" title="Моя запись">
              <UserCircleIcon size={22} aria-hidden />
            </Link>
          )}
        </span>
      }
    />
  );
}
